var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-model-selector", {
        attrs: {
          plugin: "organizationalChart",
          delegate: "getUserOrganizationList",
          "display-field": "title",
          "value-field": "id",
          placeholder: "Select Organization ...",
        },
        model: {
          value: _vm.organizationId,
          callback: function ($$v) {
            _vm.organizationId = $$v
          },
          expression: "organizationId",
        },
      }),
      _vm._v(" "),
      _c(
        "q-row",
        { attrs: { gutter: 15 } },
        [
          _c(_vm.getLeftColumn, {
            tag: "component",
            attrs: { organization: _vm.organization },
          }),
          _vm._v(" "),
          _c(_vm.getRightColumn, {
            tag: "component",
            attrs: { organization: _vm.organization },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }